import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import Navbar from './components/Navbar';
import IndicatorBar from './components/IndicatorBar';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import HoldingsPage from './pages/HoldingsPage';
import PortfoliosPage from './pages/PortfoliosPage';
import UsersPage from './pages/UsersPage';
import TransactionsPage from './pages/TransactionsPage';
import MonitoringPage from './pages/MonitoringPage';
import Form4Page from './pages/Form4Page';
import SediPage from './pages/SediPage';
import InsiderActivityPage from './pages/InsiderActivityPage';
import InstitutionsPage from './pages/InstitutionsPage';
import InsiderOwnershipPage from './pages/InsiderOwnershipPage';
import ConfigurationPage from './pages/ConfigurationPage';

function App() {
  const { user, loading, login, logout } = useAuth();

  if (loading) {
    return <div style={{ color: '#aaa', textAlign: 'center', padding: '60px' }}>Loading...</div>;
  }

  return (
    <BrowserRouter>
      {user ? (
        <div style={{ minHeight: '100vh', minWidth: '1024px', backgroundColor: '#fff', color: '#000' }}>
          <div style={{ width: '100%', height: '384px', backgroundImage: 'url(/header.jpg)', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }} />
          <Navbar username={user.username} onLogout={logout} />
          <IndicatorBar />
          <div style={{ overflowX: 'auto' }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/holdings" element={<HoldingsPage />} />
            <Route path="/portfolios" element={<PortfoliosPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/transactions" element={<TransactionsPage />} />
            <Route path="/monitoring" element={<MonitoringPage />} />
            <Route path="/form4" element={<Form4Page />} />
            <Route path="/sedi" element={<SediPage />} />
            <Route path="/insider-activity" element={<InsiderActivityPage />} />
            <Route path="/institutions" element={<InstitutionsPage />} />
            <Route path="/insiders" element={<InsiderOwnershipPage />} />
            <Route path="/configuration" element={<ConfigurationPage />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
          </div>
        </div>
      ) : (
        <Routes>
          <Route path="/login" element={<LoginPage onLogin={login} />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      )}
    </BrowserRouter>
  );
}

export default App;
